import { BaseCarouselView } from './base-carousel-view'
import { Defaults } from 'es-decorators'

@Defaults({
  additionalOptions: ['config', 'eventBus'],
  el: '#chponki-category',
  /**
   * Дефолтная конфигурация для карусели
   */
  config_: {
    loop: true,
    nav: true,
    items: 1,
    slideBy: 1,
    mouseDrag: false,
    dots: true,
    responsiveClass: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    margin: 1,
  },
})
/**
 * Вид для карусели баннеров использующей owl-carousel
 */
export class OwlCarouselView extends BaseCarouselView {
  /** @inheritDoc */
  run () {
    this.initCarousel()
  }

  /**
   * Инициализация карусели
   */
  initCarousel () {
    this.chponck = this.$el.hasClass('owl-carousel')
      ? this.$el
      : this.$('.b-chponcki')
    const config = Object.assign({}, this.config)
    const promo = this.$el.hasClass('b-promo_hidden')
      ? this.$el
      : this.$('.b-promo_hidden')
    if (this.$('.b-chponck').length === 1) {
      config.loop = false
      config.nav = false
      config.dots = false
    }
    config.onTranslated = event => {
      this.onCarouselChange(event)
    }
    this.chponck.addClass('owl-carousel')
    this.chponck.owlCarousel(config)
    promo.removeClass('b-promo_hidden')
  }

  /**
   * Признак нескольких слайдов в карусели.
   *
   * @returns {boolean}
   */
  get hasMultipleItems () {
    return (this.config.items && this.config.items > 1)
      || (this.config.responsive && Object.values(this.config.responsive).some(({ items }) => items > 1))
  }

  /**
   * Обработчик смены слайда в карусели
   * @param {Event} event Событие смены слайда/
   */
  onCarouselChange (event) {
    $(event.target).find('.owl-dot:not(.active)').animate({
      padding: 4,
    }, 200)
    $(event.target).find('.owl-dot.active').animate({
      padding: 0,
    }, 300)
    if (this.hasMultipleItems) {
      // если несколько слайдов сдвигаются в карусели то есть вероятность что последний слайд не успеет за анимацией.
      setTimeout(this.sendDataToEventBus.bind(this, event), 1000)
    } else {
      this.sendDataToEventBus(event)
    }
  }

  /**
   * @inheritDoc
   * @returns {jQuery} Текущий слайд.
   */
  getCurrentItem (event) {
    if (this.hasMultipleItems) {
      return this.$el.find('.owl-item.active').toArray()
    }
    return $(event.target).find('.owl-item').eq(event.relatedTarget.current()).get(0)
  }
}
